export const CLASS_TEMPLATE_COLUMNS = [
  { id: "name", label: "Template", alwaysVisible: true, defaultVisible: true },
  { id: "category", label: "Category", alwaysVisible: false, defaultVisible: true },
  { id: "format", label: "Format", alwaysVisible: false, defaultVisible: true },
  { id: "default_price", label: "Default price", alwaysVisible: false, defaultVisible: true },
  { id: "default_capacity", label: "Default capacity", alwaysVisible: false, defaultVisible: true },
  { id: "classes_count", label: "Classes", alwaysVisible: false, defaultVisible: true },
  { id: "sessions_count", label: "Sessions", alwaysVisible: false, defaultVisible: false },
  { id: "internal_code", label: "Internal code", alwaysVisible: false, defaultVisible: false },
  { id: "created_at", label: "Added", alwaysVisible: false, defaultVisible: false },
];

export const SORT_OPTIONS = [
  { value: "name asc", label: "Name (A-Z)" },
  { value: "name desc", label: "Name (Z-A)" },
  { value: "created_at desc", label: "Newest First" },
  { value: "created_at asc", label: "Oldest First" },
];
